module.exports = __webpack_public_path__ + "static/media/2×2灯屏.0f0211a7.png";